import { get, put } from '../utils/makeRequest';

const ADMIN_SUPPORT_ENDPOINTS = {
  GET_ALL_TICKETS: '/admin/support-tickets',
  GET_TICKET_BY_ID: '/admin/support-tickets',
  REPLY_TICKET: '/admin/support-tickets',
  UPDATE_STATUS: '/admin/support-tickets',
  PENDING_COUNT: '/admin/support-tickets/pending-count',
};

export const adminSupportService = {
  /**
   * Get all support tickets
   * @returns {Promise} - List of all support tickets
   */
  getAllTickets: async () => {
    return get(ADMIN_SUPPORT_ENDPOINTS.GET_ALL_TICKETS);
  },

  getPendingCount: async () => {
    return get(ADMIN_SUPPORT_ENDPOINTS.PENDING_COUNT);
  },

  /**
   * Get a specific support ticket by ID
   * @param {number} ticketId - The ticket ID
   * @returns {Promise} - Ticket details
   */
  getTicketById: async (ticketId) => {
    return get(`${ADMIN_SUPPORT_ENDPOINTS.GET_TICKET_BY_ID}/${ticketId}`);
  },

  /**
   * Reply to a support ticket
   * @param {number} ticketId - The ticket ID
   * @param {string} response_message - The reply message
   * @returns {Promise} - Reply result
   */
  replyToTicket: async (ticketId, response_message) => {
    return put(`${ADMIN_SUPPORT_ENDPOINTS.REPLY_TICKET}/${ticketId}/reply`, {
      response_message
    });
  },

  /**
   * Update ticket status
   * @param {number} ticketId - The ticket ID
   * @param {string} status - New status (pending, resolved, closed)
   * @returns {Promise} - Update result
   */
  updateTicketStatus: async (ticketId, status) => {
    return put(`${ADMIN_SUPPORT_ENDPOINTS.UPDATE_STATUS}/${ticketId}/status`, {
      status
    });
  },
};
